import React, { useState } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { FaRegNewspaper, FaUserCircle, FaThLarge, FaExchangeAlt, FaLayerGroup } from 'react-icons/fa';
import HomePage from '../../pages/HomePage/homepage';
import AccountsDashboard from './AccountsDashboard';
import GeneralDashboard from './GeneralDashboard';
import AccountComparator from './AccountComparator';
import AccountGroups from './AccountGroups';
import './socialAnalytics.css';

/**
 * Contenedor de Monitoreo de Medios con dos verticales:
 *   - "Noticias"     → monitoreo de noticias por keyword + sentimiento (TikTok se movió a "Por Cuenta")
 *   - "Por Cuenta"   → analítica de cuentas: Instagram, Facebook y TikTok-por-keyword (Enfoque B)
 *
 * Sustituye al antiguo HomePage en la ruta "/", pero lo reutiliza tal cual para
 * la vertical de keyword (cero reescritura del flujo que ya funciona).
 *
 * Layout en flex-column de altura completa: el switch arriba (altura fija) y el
 * panel activo ocupa el resto con min-height:0 para que el scroll interno de
 * cada vertical (p.ej. .homepage-main con height:100%) siga funcionando.
 */
export default function MediaMonitoring({ userFeatures = {} }) {
    const { user } = useAuthenticator((context) => [context.user]);
    const [vertical, setVertical] = useState('keyword');

    return (
        <div className="sa-root">
            <div className="sa-vertical-switch">
                <button
                    className={vertical === 'keyword' ? 'active' : ''}
                    onClick={() => setVertical('keyword')}>
                    <FaRegNewspaper /> Noticias
                </button>
                <button
                    className={vertical === 'account' ? 'active' : ''}
                    onClick={() => setVertical('account')}>
                    <FaUserCircle /> Redes Sociales
                </button>
                <button
                    className={vertical === 'general' ? 'active' : ''}
                    onClick={() => setVertical('general')}>
                    <FaThLarge /> Análisis competencia
                </button>
                <button
                    className={vertical === 'compare' ? 'active' : ''}
                    onClick={() => setVertical('compare')}>
                    <FaExchangeAlt /> Comparador
                </button>
                <button
                    className={vertical === 'groups' ? 'active' : ''}
                    onClick={() => setVertical('groups')}>
                    <FaLayerGroup /> Agrupaciones
                </button>
            </div>

            {/* HomePage queda montado siempre (no perder estado/peticiones);
                solo se oculta. flex-column para que su scroll interno funcione. */}
            <div className={`sa-pane ${vertical === 'keyword' ? '' : 'sa-pane-hidden'}`}>
                <HomePage userFeatures={userFeatures} />
            </div>

            {vertical === 'account' && (
                <div className="sa-pane sa-pane-scroll">
                    <AccountsDashboard username={user?.username} />
                </div>
            )}

            {vertical === 'general' && (
                <div className="sa-pane sa-pane-scroll">
                    <GeneralDashboard username={user?.username} />
                </div>
            )}

            {vertical === 'compare' && (
                <div className="sa-pane sa-pane-scroll">
                    <AccountComparator username={user?.username} />
                </div>
            )}

            {vertical === 'groups' && (
                <div className="sa-pane sa-pane-scroll">
                    <AccountGroups username={user?.username} />
                </div>
            )}
        </div>
    );
}
